import { Tab } from "@material-ui/core";
import { NavigationTabs, PageContainer, useLinkedLocation } from "lqx-react";
import * as React from "react";
import { CashMonitorPage } from "./cash-monitor";


export const IncashPage = () => {
  const $category = useLinkedLocation(2, "cash-monitor"),
    category = $category.value;

  return (
    <PageContainer>
      <NavigationTabs $value={$category}>
        <Tab label="Cash Monitor" value="cash-monitor" />
        <Tab label="Working Capital Monitor" value="working-capital-monitor" />
        <Tab label="Cash Forecast" value="cash-forecast" />
      </NavigationTabs>
      {category === "cash-monitor" ? (
        <CashMonitorPage />
      ) : category === "working-capital-monitor" ? (
        <h1> TODO </h1>
      ) : category === "cash-forecast" ? (
        <h1> TODO </h1>
      ) : (
        <h1>Wrong path</h1>
      )}
    </PageContainer>
  );
};
